// Stimulus-Controller (explizite Imports statt require.context, da esbuild).
// Identifier entsprechen den data-controller-Werten in den Views.
import { Application } from "@hotwired/stimulus"

import AdminController from "./admin_controller"
import BackarrowController from "./backarrow_controller"
import BannerController from "./banner_controller"
import DhladressoptionenController from "./dhladressoptionen_controller"
import Shop2shopsearchController from "./shop2shopsearch_controller"
import LazyLoaderController from "./lazy_loader_controller"
import ModalController from "./modal_controller"
import ModalmasterController from "./modalmaster_controller"
import RechnungsanschriftController from "./rechnungsanschrift_controller"
import SearchController from "./search_controller"
import SidebarController from "./sidebar_controller"
import TotopController from "./totop_controller"

const application = Application.start()
application.register("admin", AdminController)
application.register("backarrow", BackarrowController)
application.register("banner", BannerController)
application.register("dhladressoptionen", DhladressoptionenController)
application.register("shop2shopsearch", Shop2shopsearchController)
application.register("lazy-loader", LazyLoaderController)
application.register("modal", ModalController)
application.register("modalmaster", ModalmasterController)
application.register("rechnungsanschrift", RechnungsanschriftController)
application.register("search", SearchController)
application.register("sidebar", SidebarController)
application.register("totop", TotopController)